import { ArrowRight } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { Reveal } from "../hooks/useScrollReveal";

const IMAGES = [
  "https://customer-assets.emergentagent.com/job_tervalia-atelier/artifacts/mrcqn824_ukazka_prace_5.png",
  "https://customer-assets.emergentagent.com/job_tervalia-atelier/artifacts/h0atv326_ukazka_prace_6.png",
  "https://customer-assets.emergentagent.com/job_tervalia-atelier/artifacts/37hpnnnr_ukazka_prace_4.png",
];

export default function Services() {
  const { t } = useI18n();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-[#f4f0e9] py-24 md:py-36"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="eyebrow mb-6" data-testid="services-eyebrow">{t.services.eyebrow}</div>
          <h2
            data-testid="services-title"
            className="font-serif-hero text-[#252525] text-[34px] sm:text-[44px] md:text-[54px] leading-[1.08] max-w-[640px]"
          >
            {t.services.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-6 lg:gap-8">
          {t.services.items.map((item, i) => (
            <Reveal key={item.n}>
              <article className="tv-service-card h-full" data-testid={`service-card-${item.n}`}>
                <div className="relative overflow-hidden aspect-[4/3]">
                  <img
                    src={IMAGES[i % IMAGES.length]}
                    alt={item.title}
                    loading="lazy"
                    className="card-img w-full h-full object-cover"
                  />
                  <div className="absolute top-4 left-4 bg-[#f9f8f5]/90 backdrop-blur-sm px-3 py-1.5 text-[10px] tracking-[0.22em] font-medium text-[#4a4a45]">
                    {item.n}
                  </div>
                </div>
                <div className="p-7 md:p-8 flex flex-col grow">
                  <h3 className="font-serif text-[#252525] text-[24px] md:text-[26px] leading-[1.2]">
                    {item.title}
                  </h3>
                  <div className="mt-4 h-px w-14 bg-[#b86a55]" />
                  <p className="mt-5 text-[14.5px] leading-[1.7] text-[#4a4a45]">{item.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16 flex justify-center">
          <button
            data-testid="services-cta"
            onClick={() => scrollTo("contact")}
            className="tv-btn tv-btn-outline"
          >
            {t.services.cta}
            <ArrowRight size={14} strokeWidth={1.5} className="arrow" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
